import React from 'react';
import { Dialog } from '@headlessui/react';
import { ClockIcon } from '@heroicons/react/24/outline';

interface SessionTimeoutWarningProps {
  open: boolean;
  timeRemaining: number; // milliseconds
  onExtend: () => void;
}

export const SessionTimeoutWarning: React.FC<SessionTimeoutWarningProps> = ({
  open,
  timeRemaining,
  onExtend,
}) => {
  const minutes = Math.floor(timeRemaining / 60000);
  const seconds = Math.floor((timeRemaining % 60000) / 1000);

  return (
    <Dialog open={open} onClose={() => {}} className="relative z-50">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/30 backdrop-blur-sm" aria-hidden="true" />

      {/* Modal */}
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="mx-auto max-w-md rounded-2xl bg-white p-8 shadow-2xl transform transition-all">
          {/* Icon */}
          <div className="flex items-center justify-center w-16 h-16 mx-auto bg-gradient-to-br from-yellow-100 to-orange-100 rounded-full mb-6">
            <ClockIcon className="w-8 h-8 text-yellow-600" />
          </div>

          {/* Title */}
          <Dialog.Title className="text-2xl font-bold text-gray-900 text-center mb-3">
            Session Expiring Soon
          </Dialog.Title>

          {/* Message */}
          <p className="text-gray-600 text-center mb-2">
            You'll be automatically logged out in
          </p>

          {/* Countdown */}
          <div className="text-center mb-6">
            <span className="text-4xl font-bold text-red-600 tabular-nums">
              {minutes}:{seconds.toString().padStart(2, '0')}
            </span>
          </div>

          <p className="text-sm text-gray-500 text-center mb-6">
            due to inactivity
          </p>

          {/* Buttons */}
          <div className="flex flex-col gap-3">
            <button
              onClick={onExtend}
              className="w-full px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg hover:from-indigo-700 hover:to-purple-700 font-semibold shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
            >
              Stay Logged In
            </button>
            <a
              href="/login"
              className="w-full px-6 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 text-center font-medium transition-colors"
            >
              Log Out Now
            </a>
          </div>

          {/* Info */}
          <p className="text-xs text-gray-400 text-center mt-6">
            For your security, we log you out after 60 minutes of inactivity
          </p>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default SessionTimeoutWarning;
